"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  currentValueIs: '当前生效值为',
  inputValueIs: '输入值为',
  period: '。',
  semicolon: '；',
  colon: '：',
  comma: '，',
  input: '输入',
  isValid: '合法',
  isInvalid: '不合法',
  tip: '请回车或者点击它处自动计算最相近合法值'
};
exports.default = _default;